import useWindowDimensions from 'react-components/Hooks/useWindowDimensions'

export function useIsMobile() {
  const { width } = useWindowDimensions()
  return width <= 800
}
